<template>
  <v-autocomplete
    v-model="selectedColaboradores"
    :label="label"
    item-text="nome"
    item-value="cpf"
    :items="arrayColaboradores"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    @change="onChanged()"
    @input="itemSelecionado"
  >
    <template v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedColaboradores.length - 1 }})</span>
    </template>
    <!-- <template v-slot:item="data">
      <v-list-item>
        <v-list-item-action>
          <v-checkbox v-model="selected" color="primary" @click="check(data)"></v-checkbox>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.nome"></v-list-item-title>
          <v-list-item-subtitle v-html=" getFormartCpf(data.item.cpf)"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>-->
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
import rules from "@/utils/rules";
import Colaborador from "@/services/colaborador";
import Equipe from "@/services/equipe";
export default {
  name: "SelectColaborador",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    empresas: {
      type: Array | String,
      required: false
    },

    mounted: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: "Colaboradores"
    },
    equipes: {
      type: Array
    },
    selecionado: [Array, String]
  },

  data() {
    return {
      arrayColaboradores: [],

      selectedColaboradores: this.selecionado,
      selected: [],
      rules: rules
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"])
  },

  methods: {
    check(value) {
      this.selected.push(value);
    },
    getFormartCpf(valor) {
      return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    },
    async getColaboradores() {
      try {
        let colaboradores;
        let empresas = this.empresas;

        if (!empresas || empresas.length == 0) {
          this.arrayColaboradores = [];
          return;
        }

        if (!Array.isArray(empresas)) {
          empresas = [empresas];
        }

        if (this.getUser.papel.toUpperCase() == "VENDEDOR") {
          this.arrayColaboradores = [this.getUser.colaborador];
          return;
        }

        colaboradores = await new Colaborador().getByEmpresas(empresas);

        // if (!empresas || empresas.length == 0) {
        //   colaboradores = await new Colaborador().getAll();
        // } else {
        //   colaboradores = await new Colaborador().getByEmpresas(empresas);
        // }

        this.arrayColaboradores = colaboradores;
      } catch (error) {
        this.$toast.error(error);
      }
    },

    selectAll(all = true) {
      if (all) {
        this.selectedColaboradores = this.arrayColaboradores.map(
          value => value.cpf
        );
        this.selected = this.arrayColaboradores.map(value => value.cpf);
      } else {
        this.selectedColaboradores = [];
        this.selected = [];
      }

      this.onChanged();
    },

    onChanged() {
      const filtered = this.arrayColaboradores.filter(value =>
        this.selectedColaboradores.includes(value.cpf)
      );
      this.$emit("onChanged", filtered);
    },
    async updateEquipe(
      equipe,
      codigoEquipe,
      cnpj,
      ColaboradoresNovos,
      ColaboradoresAntigos
    ) {
      try {
        await new Equipe().updateEquipe(
          equipe,
          cnpj,
          codigoEquipe,
          ColaboradoresNovos,
          ColaboradoresAntigos
        );
      } catch (error) {
        console.error(error);
      }
    },
    itemSelecionado(colaborador) {
      const ColaboradoresAntigos = [];
      if (this.equipes !== null) {
        let equipes = [...this.equipes];
        equipes.forEach(element => {
          element.forEach(col => {
            col.colaboradores.forEach(colab => {
              if (colab.cpf_completo === colaborador[colaborador.length - 1]) {
                this.$swal
                  .confirm(
                    "Equipe Antiga :<h4><b>" + col.nome,
                    "<b></h4>Deseja mudar a Equipe desse Colaborador?"
                  )
                  .then(async () => {
                    ColaboradoresAntigos.push(...col.colaboradores);

                    var index = col.colaboradores.indexOf(colab);

                    if (index > -1) {
                      col.colaboradores.splice(index, 1);
                    }
                    let ColaboradoresNovos = col.colaboradores;

                    await this.updateEquipe(
                      col,
                      col.codigoEquipe,
                      this.empresas,
                      ColaboradoresNovos,
                      ColaboradoresAntigos
                    );
                  })
                  .catch(e => this.selectedColaboradores.pop());
              }
            });
          });
        });
      }
    }
  },

  watch: {
    empresas: {
      handler() {
        this.selectedColaboradores = [];
        this.getColaboradores();
      },
      deep: true
    },
    selecionado: {
      handler() {
        this.selectedColaboradores = this.selecionado;
      },
      deep: true
    }
  },

  mounted() {
    if (this.mounted) {
      this.getColaboradores();
    }
  }
};
</script>
